import { clientWithAuth } from "@/api/kuber-api";
import {
  GenerateArchiveTransportDocumentsController_AgGenerateArchiveTransportDocumentsRequest,
  GenerateMergedTransportDocumentsOrderFileController_AgGenerateMergedTransportDocumentsOrderFileRequest,
  GenerateOrderInfoFileController_AgDocsOutputFileResponse,
  GenerateOrderInfoFileController_AgOrderIdCodeRequest,
  GetCustomerDocumentPackageController_AgCustomerDocumentPackageResponse,
  GetCustomerDocumentPackageListController_AgCustomerDocumentPackageListResponse,
} from "@/api/kuber-api/codegen";
import {
  DOWNLOAD_PDF_ORDER,
  GENERATE_ARCHIVE_TD_FILE,
  GENERATE_MERGED_TD_FILE,
  GET_DOCS_LIST,
  GET_DOCS_PACKAGE,
} from "@/api/kuber-api/endpoints";
import { DownloadFileResponse } from "@/domain/common";
import { GetDocumentsRequest } from "@/domain/docs";

export function getDocumentList(
  request: GetDocumentsRequest,
): Promise<GetCustomerDocumentPackageListController_AgCustomerDocumentPackageListResponse> {
  const isFilterEmpty = Object.keys(request.filter).length === 0;

  const filters = isFilterEmpty
    ? ""
    : `&${Object.entries(request.filter)
        .map(([key, value]) => `${key}=${value}`)
        .join("&")}`;
  const url = `${GET_DOCS_LIST}?offset=${request.pagination.offset}&limit=${request.pagination.limit}${filters}`;
  return clientWithAuth
    .get<GetCustomerDocumentPackageListController_AgCustomerDocumentPackageListResponse>(url)
    .then((response) => response.data);
}

export function getDocumentPackage(request: {
  documentPackageId: string;
}): Promise<GetCustomerDocumentPackageController_AgCustomerDocumentPackageResponse> {
  const url = GET_DOCS_PACKAGE + request.documentPackageId;
  return clientWithAuth
    .get<GetCustomerDocumentPackageController_AgCustomerDocumentPackageResponse>(url)
    .then((response) => response.data);
}

export function downloadPdfOrder(
  request: GenerateOrderInfoFileController_AgOrderIdCodeRequest,
): Promise<GenerateOrderInfoFileController_AgDocsOutputFileResponse> {
  return clientWithAuth.post(DOWNLOAD_PDF_ORDER, request).then((response) => response.data);
}

export function generateArchiveTdFile(
  request: GenerateArchiveTransportDocumentsController_AgGenerateArchiveTransportDocumentsRequest,
): Promise<DownloadFileResponse> {
  return clientWithAuth
    .post(GENERATE_ARCHIVE_TD_FILE, request, {
      responseType: "blob",
    })
    .then((response) => {
      const header = response.headers["content-disposition"];
      const parts = header.split(";");
      return { fileName: parts[1].split("=")[1].replaceAll('"', ""), file: response.data };
    });
}

export function generateMergedTdFile(
  request: GenerateMergedTransportDocumentsOrderFileController_AgGenerateMergedTransportDocumentsOrderFileRequest,
): Promise<DownloadFileResponse> {
  return clientWithAuth
    .post(GENERATE_MERGED_TD_FILE, request, {
      responseType: "blob",
    })
    .then((response) => {
      const header = response.headers["content-disposition"];
      const parts = header.split(";");
      return { fileName: parts[1].split("=")[1].replaceAll('"', ""), file: response.data };
    });
}
